import { api } from "./apiClient";
import { Parametrico, ParametricoUpdate } from "@/types/parametrico";

export const parametricosService = {
  getAll: (includeInactive = false) =>
    api.get<Parametrico[]>(`/parametricos/?include_inactive=${includeInactive}`),

  getByClave: (clave: string) =>
    api.get<Parametrico>(`/parametricos/${clave}`),

  update: (clave: string, data: ParametricoUpdate) =>
    api.put<Parametrico>(`/parametricos/${clave}`, data),

  invalidateCache: () =>
    api.post<{ message: string }>("/parametricos/invalidate-cache", {}),

  seed: () =>
    api.post<{ message: string; created: number; skipped: number }>("/parametricos/seed", {}),

  getPlazosDisponibles: () =>
    api.get<{
      plazos: Array<{ value: string; label: string }>;
      plazos_adelanto_nomina: Array<{ value: string; label: string }>;
      todos: Array<{ value: string; label: string }>;
    }>("/parametricos/plazos-disponibles"),
};
